// extracted by mini-css-extract-plugin
export default {"DeleteModelsDialog":"DeleteModelsDialog_DeleteModelsDialog__Dwv8W"};